"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var AXSLoader_1 = __importDefault(require("../../elements/AXSLoader"));
var Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  color: ", ";\n  display: ", ";\n  font-size: 15px;\n  height: 48px;\n  padding: ", ";\n  width: ", ";\n\n  &:focus {\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n    outline: none;\n  }\n\n  &:hover {\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n    outline: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-style: solid;\n  border-width: 1px;\n  border-color: ",
    ";\n  color: ",
    ";\n  display: ", ";\n  font-size: 15px;\n  height: 48px;\n  padding: ",
    ";\n  width: ", ";\n\n  &:focus {\n    background-color: ",
    ";\n    border: ",
    ";\n    color: ",
    ";\n    outline: none;\n  }\n\n  &:hover {\n    background-color: ", ";\n    border: ",
    ";\n    color: ",
    ";\n    outline: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderColor = _a.borderColor, borderColorError = _a.borderColorError, borderless = _a.borderless, theme = _a.theme, error = _a.error;
    return error
        ? utils_1.parseThemePath(borderColorError, theme, colors_1.colors.RED_300)
        : borderless ? 'transparent' : utils_1.parseThemePath(borderColor, theme, colors_1.colors.GREY_400);
}, function (_a) {
    var color = _a.color, disabled = _a.disabled, disabledColor = _a.disabledColor, theme = _a.theme;
    return (!disabled ? utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650) : utils_1.parseThemePath(disabledColor, theme, colors_1.colors.GREY_300));
}, function (_a) {
    var inline = _a.inline;
    return (inline ? 'inline-block' : 'block');
}, function (_a) {
    var icon = _a.icon, iconPosition = _a.iconPosition;
    return icon && iconPosition === 'right'
        ? '12px 32px 12px 12px'
        : icon && iconPosition !== 'right'
            ? '12px 12px 12px 32px'
            : '12px';
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
}, function (_a) {
    var backgroundColorActive = _a.backgroundColorActive, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColorActive, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderless = _a.borderless, borderColorActive = _a.borderColorActive, borderColorError = _a.borderColorError, error = _a.error, theme = _a.theme;
    return !borderless ? "1px solid " + (error ? utils_1.parseThemePath(borderColorError, theme, colors_1.colors.RED_300)
        : utils_1.parseThemePath(borderColorActive, theme, colors_1.colors.GREY_300)) : 'none';
}, function (_a) {
    var colorActive = _a.colorActive, disabled = _a.disabled, disabledColor = _a.disabledColor, theme = _a.theme;
    return (!disabled ? utils_1.parseThemePath(colorActive, theme, colors_1.colors.GREY_650) : utils_1.parseThemePath(disabledColor, theme, colors_1.colors.GREY_300));
}, function (_a) {
    var backgroundColorHover = _a.backgroundColorHover, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColorHover, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderless = _a.borderless, borderColorHover = _a.borderColorHover, borderColorError = _a.borderColorError, error = _a.error, theme = _a.theme;
    return !borderless ? "1px solid " + (error ? utils_1.parseThemePath(borderColorError, theme, colors_1.colors.RED_300)
        : utils_1.parseThemePath(borderColorHover, theme, colors_1.colors.GREY_300)) : 'none';
}, function (_a) {
    var colorHover = _a.colorHover, disabled = _a.disabled, disabledColor = _a.disabledColor, theme = _a.theme;
    return (!disabled ? utils_1.parseThemePath(colorHover, theme, colors_1.colors.GREY_650) : utils_1.parseThemePath(disabledColor, theme, colors_1.colors.GREY_300));
}, function (_a) {
    var placeholderColor = _a.placeholderColor, theme = _a.theme;
    return utils_1.parseThemePath(placeholderColor, theme, colors_1.colors.GREY_450);
});
var FieldContainer = styled_components_1.default(AXSFlexItem_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  position: relative;\n  width: ", ";\n"], ["\n  margin-bottom: 8px;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width ? width : '100%';
});
var Icon = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  left: ", ";\n  right: ", ";\n  position: absolute;\n  top: 12px;\n"], ["\n  left: ", ";\n  right: ", ";\n  position: absolute;\n  top: 12px;\n"])), function (_a) {
    var iconPosition = _a.iconPosition;
    return iconPosition !== 'right' ? '10px' : 'auto';
}, function (_a) {
    var iconPosition = _a.iconPosition;
    return iconPosition === 'right' ? '10px' : 'auto';
});
var Loading = styled_components_1.default(AXSLoader_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  right: 10px;\n  position: absolute;\n  top: 15px;\n"], ["\n  right: 10px;\n  position: absolute;\n  top: 15px;\n"])));
var AXSFormInput = /** @class */ (function (_super) {
    __extends(AXSFormInput, _super);
    function AXSFormInput(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            _this.inputField.current.focus();
        };
        _this.inputField = React.createRef();
        return _this;
    }
    AXSFormInput.prototype.render = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, disabledColor = _a.disabledColor, error = _a.error, icon = _a.icon, iconPosition = _a.iconPosition, id = _a.id, inline = _a.inline, placeholderColor = _a.placeholderColor, readOnly = _a.readOnly, width = _a.width, loading = _a.loading;
        return (React.createElement(FieldContainer, { className: classnames_1.default(['c-axs-form-field', className]), width: width },
            React.createElement(Input, __assign({ disabled: disabled || loading, disabledColor: disabledColor, error: error, loading: loading, icon: icon, iconPosition: iconPosition, id: id, inline: inline, placeholderColor: placeholderColor, readOnly: readOnly, width: width }, this.props, { className: "c-axs-form-field__input" })),
            loading ? React.createElement(Loading, { width: "20px", height: "20px", active: true }) : null,
            icon && !loading ? React.createElement(Icon, { iconPosition: iconPosition }, icon) : null));
    };
    AXSFormInput.defaultProps = {
        backgroundColor: 'axsui.forms.backgroundColor',
        backgroundColorActive: 'axsui.forms.backgroundColorActive',
        backgroundColorHover: 'axsui.forms.backgroundColorHover',
        borderColor: 'axsui.forms.borderColor',
        borderColorActive: 'axsui.forms.borderColorActive',
        borderColorError: 'axsui.forms.borderColorError',
        borderColorHover: 'axsui.forms.borderColorHover',
        color: 'axsui.forms.color',
        colorActive: 'axsui.forms.colorActive',
        colorError: 'axsui.forms.colorError',
        colorHover: 'axsui.forms.colorHover',
        disabledColor: 'axsui.forms.colorDisabled',
        placeholderColor: 'axsui.forms.placeholder',
    };
    return AXSFormInput;
}(React.Component));
exports.default = AXSFormInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map